import React, {Component} from 'react';
import { HashRouter,Switch, Route, Redirect } from 'react-router-dom';

import Dashboard from '../page/dashboard/Dashboard';
import Unit from '../page/master/Unit';
import User from '../page/master/User';

import Produk from '../page/stok/Produk';
import Supplier from '../page/master/Supplier';
import Client from '../page/master/Client';
import ProdukOffice from '../page/stok/ProdukOffice';
import ProdukHistory from '../page/laporan/ProdukHistory';


const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        sessionStorage.getItem('ses_mogi') ? (
            <Component {...props} />
        ) : (
                <Redirect to={{
                    pathname: '/login',
                  state: { from: props.location }
                }} />
        
      )
    )} />
);

export default class Content extends Component {
	render() {
        return (
        		<section className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                			<HashRouter>
                        		<Switch>
                        			<Route exact path='/' component={Dashboard}></Route>
                                    <Route exact path='/dashboard' component={Dashboard}></Route>
                                    <Route exact path='/supplier' component={Supplier}></Route>
                                    <Route exact path='/client' component={Client}></Route>
                                    <Route exact path='/unit' component={Unit}></Route>
                                    <Route exact path='/user' component={User}></Route>

                                    <Route exact path='/product-office' component={ProdukOffice}></Route>
                                    <Route exact path='/report-product-history' component={ProdukHistory}></Route>
                        		</Switch>
                        	</HashRouter>
                        </div>
                    </div>
                </section>
        )
    }

}